<template>
  <div ref="mainContainer" class="main-container">
    <MessageItem
      v-for="(msg, index) in messages"
      :key="index"
      :role="msg.role"
      :time="msg.time"
      :content="msg.content"
      :state="msg.state"
    />
  </div>
</template>

<script>
import MessageItem from "./MessageItem.vue";
export default {
  name: "MessageBoxMain",
  components: {
    MessageItem,
  },
  props: {
    messages: Array,
    sessionType: Number,
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(() => {
          const mainContainer = this.$refs.mainContainer;
          if (mainContainer) {
            mainContainer.scrollTop = mainContainer.scrollHeight;
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  padding: 20px;
  overflow: auto;
  box-sizing: border-box;
  height: 500px;
  position: relative;

  /* &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('../../../../../assets/ai/bg.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    // background-attachment: fixed;
    opacity: 0.3;
    z-index: 1;
  } */
}
</style>
